import { useEffect } from "react";
import Discipline from "../../api/models/discipline";
import { updateDiscipline, updateDisciplineId } from "../../slices/userSlice";
import { useDispatch } from 'react-redux';

/**
 * Applies any other persistent data from local storage to redux, if available
 */
export const useApplyLocalStorage = () => {
    const dispatch = useDispatch();

    useEffect(() => {
        getDiscipline();
    }, []);

    /**
     * Retrieves the discipline from local storage and updates the state with it, if it exists.
     */
    const getDiscipline = () => {
        //Get our disicpline from local storage
        const disciplineId = localStorage.getItem('disciplineId');
        const disciplineJson = localStorage.getItem('discipline');
        let discipline: Discipline | undefined = undefined;

        //Unserialize our discipline if it exists
        if (disciplineJson && disciplineJson !== '') {
            discipline = JSON.parse(disciplineJson);

            //If so, set it
            if (discipline) {
                dispatch(updateDiscipline(discipline));
                dispatch(updateDisciplineId({ disciplineId: Number(disciplineId) }));
                return;
            }

            //If not and the discipline is empty, set it
            if (disciplineId && disciplineId !== '') {
                dispatch(updateDisciplineId({ disciplineId: Number(disciplineId) }));
            }
        }
    }
}